import React from "react";

import { useDispatch, useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import { Icon, Snackbar, SnackbarContent } from "@material-ui/core";
import { clearSnackbar } from "../../actions/snackBar";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./styles";

export const SuccessSnackbar = () => {
  const dispatch = useDispatch();
  const classes = styles();

  const {
    successSnackbarMessage,
    successSnackbarOpen,
    typeSnackBar
  } = useSelector(state => state.snackBar);

  const handleClose = () => {
    dispatch(clearSnackbar());
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      open={successSnackbarOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      aria-describedby="client-snackbar"
      //   message={
      //     <span id="client-snackbar">
      //       <Icon>check_circle</Icon>
      //       {successSnackbarMessage}
      //     </span>
      //   }
    >
      <SnackbarContent
        role="alert"
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
        aria-describedby="message-id2"
        className={
          typeSnackBar === "Success"
            ? classes.snackbarStyleViaNestedContent
            : classes.snackbarStyleViaNestedContentError
        }
        message={
          <div className={classes.snackContent}>
            <div className={classes.iconContent}>
              {typeSnackBar === "Success" ? (
                <CheckCircleOutlineIcon />
              ) : (
                <ErrorOutlineIcon />
              )}
            </div>
            <span id="message-id2">
              <div>{successSnackbarMessage}</div>
            </span>
          </div>
        }
      />
    </Snackbar>
  );
};
